import { render, staticRenderFns } from "./promote-adverts.vue?vue&type=template&id=63168ef7"
import script from "./promote-adverts.vue?vue&type=script&lang=ts"
export * from "./promote-adverts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports